export default __webpack_public_path__ + "static/media/pic99.edf2dfbe.jpg";